import React from 'react'

import { RouteOffCanvas } from '@ztechapps/webui.util'

type TaskDetailFlyoutProps = {
  children: React.ReactNode
  listRoutePath: string
}

export const TaskDetailFlyout = ({ children, listRoutePath }: TaskDetailFlyoutProps) => {
  return (
    <RouteOffCanvas listRoutePath={listRoutePath} defaultWidth="70%" widthStorageKey="task-detail-flyout-width">
      {children}
    </RouteOffCanvas>
  )
}
